import { render } from "./vh-paginate.vue?vue&type=template&id=7a681941&scoped=true"
import script from "./vh-paginate.vue?vue&type=script&lang=js"
export * from "./vh-paginate.vue?vue&type=script&lang=js"

import "./vh-paginate.vue?vue&type=style&index=0&id=7a681941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a681941"]])

export default __exports__